// extracted by mini-css-extract-plugin
module.exports =  {"root":"SYARrgQGbiQLB2NeZWKq","title":"QpAXIgMJ0P9YDMEThcdw","description":"uihUlI52zwChrMmD8Izy","wide":"X0KVkJLpZvRYXEaJ144D","actions":"yZ3M2ymfrRirGYQaNcb2"};